/**
 * Meia-prancha (prancha curta de resgate).
 *
 * Dispositivo rígido intermediário utilizado na retirada da vítima sentada.
 * Estabiliza a coluna tóraco-lombar e cervical antes do posicionamento e
 * transição para a prancha longa.
 */

export interface EstadoMeiaPrancha {
  posicionada: boolean
  cintasFixadas: boolean
}

export const ESTADO_MEIA_PRANCHA_INICIAL: EstadoMeiaPrancha = {
  posicionada: false,
  cintasFixadas: false,
}

/** Comprimento didático da meia prancha (aprox. 80 cm a 90 cm de sustentação dorsal). */
export const COMPRIMENTO_MEIA_PRANCHA = 0.85
export const LARGURA_MEIA_PRANCHA = 0.42
export const ESPESSURA_MEIA_PRANCHA = 0.035

/**
 * Retorna o índice de estabilidade da coluna durante a rotação da extração.
 * Sem meia-prancha: a estabilidade depende unicamente da técnica manual.
 * Com meia-prancha posicionada e cintas fixadas: rigidez vertebral máxima (1.0).
 */
export function indiceEstabilidadeExtracao(
  meiaPrancha: EstadoMeiaPrancha,
  colarCervical: boolean,
): { indice: number; leitura: string } {
  if (meiaPrancha.posicionada && meiaPrancha.cintasFixadas && colarCervical) {
    return {
      indice: 1.0,
      leitura: 'Coluna cervical e tóraco-lombar completamente estabilizadas em bloco.',
    }
  }

  if (meiaPrancha.posicionada && colarCervical) {
    return {
      indice: 0.85,
      leitura: 'Meia-prancha apoiada e colar ativo. Ajuste as cintas para fixação total.',
    }
  }

  if (colarCervical) {
    return {
      indice: 0.65,
      leitura: 'Cervical imobilizada pelo colar. Coluna torácica e lombar suscetíveis a flexão no giro.',
    }
  }

  if (meiaPrancha.posicionada) {
    return {
      indice: 0.45,
      leitura: 'Meia-prancha presente, mas sem colar cervical. Risco de torção cervical na rotação.',
    }
  }

  return {
    indice: 0.25,
    leitura: 'Sem estabilização mecânica. Rotação requer controle manual rígido com alto risco raquimedular.',
  }
}

